import {
  faChevronDown,
  faChevronUp,
  faClock,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button } from "react-bootstrap";
import Link from "../Link";
import hours from "../../mocks/hours.json";
import minutes from "../../mocks/minutes.json";
import { isEmpty } from "lodash";

const TimePicker = ({
  fields,
  values,
  setFieldValue,
  errorMsg,
  currentFieldName,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndexMin, setCurrentIndexMin] = useState(0);
  const arrowUp = "ArrowUp";
  const arrowDown = "ArrowDown";
  console.log(currentFieldName + ".processTimeHours");
  // const value = !isEmpty(currentFieldName) ?
  const onReset = () => {
    setCurrentIndex(0);
    setCurrentIndexMin(0);
    setFieldValue(
      isEmpty(currentFieldName)
        ? fields.processTimeHours
        : currentFieldName + ".processTimeHours",
      isEmpty(currentFieldName) ? null : currentIndex
    );
    setFieldValue(
      isEmpty(currentFieldName)
        ? fields.processTimeMinutes
        : currentFieldName + ".processTimeMinutes",
      isEmpty(currentFieldName) ? null : currentIndexMin
    );
  };

  useEffect(() => {
    if (
      values[fields.processTimeHours] !== null ||
      values[fields.processTimeMinutes] !== null
    ) {
      setCurrentIndex(values[fields.processTimeHours]);
      setCurrentIndexMin(values[fields.processTimeMinutes]);
    }
  }, [isOpen]);

  const onSubmit = () => {
    console.log("hitsubmit");
    setFieldValue(
      isEmpty(currentFieldName)
        ? fields.processTimeHours
        : currentFieldName + ".processTimeHours",
      currentIndex
    );
    setFieldValue(
      isEmpty(currentFieldName)
        ? fields.processTimeMinutes
        : currentFieldName + ".processTimeMinutes",
      currentIndexMin
    );
    // isEmpty(currentFieldName) ? setFieldValue( currentFieldName + ".time",currentIndexMin): null;

    setIsOpen(false);
  };

  const handleKeyHours = (event) => {
    if (event === "ArrowUp") {
      setCurrentIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : prevIndex
      );
    } else if (event === "ArrowDown") {
      setCurrentIndex((prevIndex) =>
        prevIndex < hours.data.length - 1 ? prevIndex + 1 : prevIndex
      );
    }
  };

  const handleKeyMinutes = (event) => {
    if (event === "ArrowUp") {
      setCurrentIndexMin((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : prevIndex
      );
    } else if (event === "ArrowDown") {
      setCurrentIndexMin((prevIndex) =>
        prevIndex < minutes.data.length - 1 ? prevIndex + 1 : prevIndex
      );
    }
  };

  return (
    <>
      <div className="time-picker d-flex">
        <div className="width-25 ml-4p">
          {values[fields.processTimeHours] === null
            ? "hh"
            : hours.data[values[fields.processTimeHours]].label}
        </div>
        <div className="width-10">:</div>
        <div className="width-30">
          {values[fields.processTimeMinutes] === null
            ? "mm"
            : minutes.data[values[fields.processTimeMinutes]].label}
        </div>
        <FontAwesomeIcon
          icon={faClock}
          className="width-30 mt-4p"
          cursor="pointer"
          onClick={() => {
            setIsOpen(true);
            if (isOpen === true) {
              setIsOpen(false);
            }
          }}
        />
      </div>
      <p className="error-message-deferral">{errorMsg}</p>
      <div className="mt-15">
        {isOpen === true && (
          <div className="time-picker-1 d-flex">
            <div className="ml-5r width-30">
              <FontAwesomeIcon
                icon={faChevronUp}
                cursor="pointer"
                onClick={() => {
                  handleKeyHours(arrowUp);
                }}
              />
              <div>{hours.data[currentIndex].label}</div>
              <FontAwesomeIcon
                icon={faChevronDown}
                cursor="pointer"
                onClick={() => {
                  handleKeyHours(arrowDown);
                }}
              />
            </div>

            <div>
              <div className="width-10 mt-1r">:</div>
            </div>

            <div className="ml-5r width-30">
              <FontAwesomeIcon
                icon={faChevronUp}
                cursor="pointer"
                onClick={() => {
                  handleKeyMinutes(arrowUp);
                }}
              />
              <div>{minutes.data[currentIndexMin].label}</div>
              <FontAwesomeIcon
                icon={faChevronDown}
                cursor="pointer"
                onClick={() => {
                  handleKeyMinutes(arrowDown);
                }}
              />
            </div>

            <div className="ml-1r">
              <Button
                variant="primary"
                size="sm"
                className="mb-5r"
                onClick={() => {
                  onSubmit();
                }}
              >
                OK
              </Button>
              <Link
                onClick={() => {
                  onReset();
                }}
              >
                RESET
              </Link>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TimePicker;
